import { handleOtpExpired } from "../../assets/js/handleOtpExpired";
import { http } from "../../assets/js/http";
import { captcha } from "../../assets/js/vue/utlis/captcha";

/**
 * Сохраняет форму PAYMENT_STICKER
 * @see https://wiki.domrf.ru/pages/viewpage.action?pageId=223418702
 * @param {object} data
 * @returns 
 */
export const paymentSticker = async (data) => {
  await captcha.check();
  return http.post('/rest/v1/paymentSticker', { data }, { includeSessionId: true })
    .catch((e) => handleOtpExpired(e, data.type, data.attributes.phone));
}